import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import './components/multiselect';
import './components/pricelist';
import './components/referenceSlider';
import './components/tariffSlider';
import './components/changelog';
import './components/main';
